import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsDividerCss = ".pds-divider{background:var(--pine-color-border);display:-ms-flexbox;display:flex;margin:0;width:100%}.pds-divider--vertical{height:100%;width:1px}.pds-divider--offset-xxs{margin:0 calc(var(--pine-dimension-2xs) * -1);padding:0 var(--pine-dimension-2xs)}.pds-divider--offset-xxs.pds-divider--vertical{margin:calc(var(--pine-dimension-2xs) * -1) 0;padding:var(--pine-dimension-2xs) 0}.pds-divider--offset-xs{margin:0 calc(var(--pine-dimension-xs) * -1);padding:0 var(--pine-dimension-xs)}.pds-divider--offset-xs.pds-divider--vertical{margin:calc(var(--pine-dimension-xs) * -1) 0;padding:var(--pine-dimension-xs) 0}.pds-divider--offset-sm{margin:0 calc(var(--pine-dimension-sm) * -1);padding:0 var(--pine-dimension-sm)}.pds-divider--offset-sm.pds-divider--vertical{margin:calc(var(--pine-dimension-sm) * -1) 0;padding:var(--pine-dimension-sm) 0}.pds-divider--offset-md{margin:0 calc(var(--pine-dimension-md) * -1);padding:0 var(--pine-dimension-md)}.pds-divider--offset-md.pds-divider--vertical{margin:calc(var(--pine-dimension-md) * -1) 0;padding:var(--pine-dimension-md) 0}.pds-divider--offset-lg{margin:0 calc(var(--pine-dimension-lg) * -1);padding:0 var(--pine-dimension-lg)}.pds-divider--offset-lg.pds-divider--vertical{margin:calc(var(--pine-dimension-lg) * -1) 0;padding:var(--pine-dimension-lg) 0}.pds-divider--offset-xl{margin:0 calc(var(--pine-dimension-xl) * -1);padding:0 var(--pine-dimension-xl)}.pds-divider--offset-xl.pds-divider--vertical{margin:calc(var(--pine-dimension-xl) * -1) 0;padding:var(--pine-dimension-xl) 0}.pds-divider--offset-xxl{margin:0 calc(var(--pine-dimension-2xl) * -1);padding:0 var(--pine-dimension-2xl)}.pds-divider--offset-xxl.pds-divider--vertical{margin:calc(var(--pine-dimension-2xl) * -1) 0;padding:var(--pine-dimension-2xl) 0}@media (max-width: 767px){.pds-divider--vertical{display:none}}";

const PdsDivider$1 = /*@__PURE__*/ proxyCustomElement(class PdsDivider extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Sets divider to display vertically.
         * @defaultValue false
         */
        this.vertical = false;
    }
    classNames() {
        const classNames = ['pds-divider'];
        if (this.vertical) {
            classNames.push('pds-divider--vertical');
        }
        if (this.offset) {
            const offsetClassName = 'pds-divider--offset-' + this.offset;
            classNames.push(offsetClassName);
        }
        return classNames.join(' ');
    }
    render() {
        return (h(Host, { key: '320aa3a83547a773630fbb1a1d8d9e57d3f54477', id: this.componentId }, h("hr", { key: '1d1b7aaf8c783ecad6a1b5ad91bd258acb21046b', class: this.classNames() })));
    }
    static get style() { return pdsDividerCss; }
}, [1, "pds-divider", {
        "componentId": [1, "component-id"],
        "offset": [1],
        "vertical": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsDivider$1);
            }
            break;
    } });
}

const PdsDivider = PdsDivider$1;
const defineCustomElement = defineCustomElement$1;

export { PdsDivider, defineCustomElement };
//# sourceMappingURL=pds-divider.js.map

//# sourceMappingURL=pds-divider.js.map